export default {
    mapLandmarkImport_landmark:'Punto de referencia',
    mapLandmarkImport_ImportTitle:'Importar Puntos de referencia',
    mapLandmarkImport_downloadTemplate:'Descargar Plantilla',
    mapLandmarkImport_fieldsRequied:'Error en la validación del archivo. Comprueba que todos los campos estén completos y que los nombres de las columnas coincidan con la plantilla esperada',
    mapLandmarkImport_formatSupport:'Formato CSV admitido: coma, punto y coma, tabulador.',
    mapLandmarkImport_import:'Importar',
    mapLandmarkImport_titleEditImport:'No se encontraron los siguientes puntos de referencia. Por favor corrija cualquier error',
    mapLandmarkImport_fieldsAdressRequied:'Hay un problema con los datos de ubicación: asegúrese de que la dirección, la latitud y la longitud (o los campos obligatorios) estén presentes y correctamente nombrados.',
    mapLandmarkImport_correctErrors:'Se presentaron algunos errores en la importacion, para corregirlos presione clic aqui',
    mapLandmarkImport_success:'Importación exitosa de puntos de referencia',
    mapLandmarkImport_maxSizeFile:'Tamaño máximo de archivo 5 mb',
    mapLandmarkImport_chooseFile:'Seleccionar Archivo',
    mapLandmarkImport_errorRadius:'Error en la columna radio',
    mapLandmarkImport_errorTag:'El Tag no existe',
    mapLandmarkImport_errorAddress:'Error en el formato de la dirección',
    mapLandmarkImport_columnError: "Columnas con Error"
}